import { EVENT_TYPE } from '../../model/events';
import RestClient from '../RestClient';

import { Container, GRAPHQL_GATEWAY_PATH, GraphQLRequest } from './model';

export interface ActivitiesEvent {
  eventType: EVENT_TYPE;
}

export interface ActivitiesJiraIssue {
  issueKey: string;
}

export type ActivitiesExtension = ActivitiesJiraIssue;

export interface ActivitiesObject {
  cloudId: string;
  containers?: Container[];
  contributors?: ContributorConnection[];
  events: ActivitiesEvent[];
  extension?: ActivitiesExtension;
  iconUrl: string;
  id: string;
  name: string;
  product: string; // right now this could be 'jira'
  url: string;
}

const ACTIVITIES_LIMIT = 50;

const ACTIVITIES = `
  nodes {
    id
    timestamp
    object {
      id
      name
      cloudId
      url
      iconUrl
      containers {
        name
      }
      contributors {
        profile {
          accountId
          name
          picture
        }
      }
      events {
        eventType
      }
      extension {
        ... on ActivitiesJiraIssue {
          issueKey
        }
      }
    }
  }
`;

const ACTIVITIES_QUERY = `
    query start_Activities($first: Int) {
      activities {
        workedOn(first: $first) {
          ${ACTIVITIES}
        }
        myViewed(first: $first) {
          ${ACTIVITIES}
        }
      }
    }
    `;

export interface ContributorConnection {
  profile: {
    accountId: string;
    name?: string;
    picture: string;
  };
}

export interface ActivitiesConnectionItem {
  id: string;
  object: ActivitiesObject;
  timestamp: string;
}

export interface ActivitiesConnection {
  nodes?: ActivitiesConnectionItem[];
}

export interface ActivitiesTabsConnection {
  activities: {
    myViewed: ActivitiesConnection;
    workedOn: ActivitiesConnection;
  };
}

export interface ActivitiesDataTabsConnection {
  data?: ActivitiesTabsConnection;
}

class ActivitiesClient extends RestClient {
  async getActivities(): Promise<ActivitiesDataTabsConnection> {
    return this.postResource<ActivitiesDataTabsConnection, GraphQLRequest>(GRAPHQL_GATEWAY_PATH, {
      operationName: 'start_Activities',
      query: ACTIVITIES_QUERY,
      variables: {
        first: ACTIVITIES_LIMIT,
      },
    });
  }
}

export default new ActivitiesClient();
